import { render, staticRenderFns } from "./BulkSingleClaimAdd.vue?vue&type=template&id=58883f50&scoped=true&"
import script from "./BulkSingleClaimAdd.vue?vue&type=script&lang=js&"
export * from "./BulkSingleClaimAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58883f50",
  null
  
)

export default component.exports